// This file was automatically generated from appchart.visitNote.subBulletDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote.subBulletDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.subBulletDialog.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><ol class="sub-bullets-content quickSelectContainer"></ol></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.subBulletDialog.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList6714 = opt_data.list;
  var itemListLen6714 = itemList6714.length;
  for (var itemIndex6714 = 0; itemIndex6714 < itemListLen6714; itemIndex6714++) {
    var itemData6714 = itemList6714[itemIndex6714];
    output.append('<li><button type="button" class="el8button quickSelectButton sub-bullet" _index="', soy.$$escapeHtml(itemIndex6714), '">', soy.$$escapeHtml(itemData6714), '</button></li>');
  }
  output.append('<li><button type="button" class="el8button quickSelectButton sub-bullet">Add New Empty Bullet</button></li>');
  if (!opt_sb) return output.toString();
};
